import React, {useEffect} from 'react';
import OutlookCalendarOauthButton from './oauth-button/OutlookCalendarOauthButton';
import {trackEvent} from '../../../tracking/amplitude/TrackingV2';
import {TRACKING_OBJECTS} from '../../../tracking/amplitude/constants/TrackingObjects';

export type OutlookCalendarOAuthProps = {
	calendarTokenError?: string;
	page: string;
};

const OutlookCalendarOAuth = ({calendarTokenError, page}: OutlookCalendarOAuthProps): JSX.Element => {
	useEffect(() => {
		trackEvent(TRACKING_OBJECTS.LINK_OUTLOOK_CALENDAR_ACCOUNT, 'Shown');
	}, []);

	return (
		<div data-cy={'outlook-calendar-oauth-button'}>
			<OutlookCalendarOauthButton calendarTokenError={calendarTokenError} page={page} />
		</div>
	);
};

export default OutlookCalendarOAuth;
